import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import { useLanguage } from "../context/LanguageContext";

export default function AboutText({ className = "" }: { className?: string }) {
  const { t } = useLanguage();

  return (
    <section id="about" className={`bg-white pt-24 pb-4 sm:pb-0 md:pt-32 ${className}`}>
      <div className="container-industrial">
        <Reveal>
          <SectionHeading title={t("aboutTitle")} description={t("aboutDescription")} />
        </Reveal>
      </div>
    </section>
  );
}
